// src/menu-items/dev.js
import { IconSend, IconCode } from '@tabler/icons-react';

const devSection = {
  id: 'dev-tools',
  title: 'Developer Tools',
  type: 'group',
  children: [
    {
      id: 'dispatchNotifications',
      title: 'Dispatch Notifications',
      type: 'item',
      url: '/dev/notifications',
      icon: IconSend,
      breadcrumbs: false
    },
    {
      id: 'apiInspector',
      title: 'API Endpoints',
      type: 'item',
      url: '/dev',
      icon: IconCode,
      breadcrumbs: false
    }
  ]
};

export default devSection;
